import React from "react";
import { Col, Row } from "antd";
import moment from "moment";

import {
  BasicInfoCard,
  DependentIcon,
  InfoText,
  AdviseeIcon,
} from "./SummaryInfoCard.styles";
import Locale from "react-intl-universal";

const ContentDisplay = ({
  isDisplayInSmallerContainer,
  textToDisplay,
  isBold,
}) => {
  return (
    <Col span={isDisplayInSmallerContainer ? 24 : 12} xl={12}>
      <InfoText fontWeight={isBold ? "bold" : "regular"}>
        {textToDisplay}
      </InfoText>
    </Col>
  );
};

const SummaryInfoCard = ({
  name,
  age,
  dob,
  dependentYears,
  noOfDependentFamilyMember = 0,
  occupation,
  isInDetailPage = true,
}) => {
  return (
    <Row gutter={[32, 32]}>
      <Col span={12}>
        <BasicInfoCard>
          <Row align="middle" style={{ marginBottom: "32px" }}>
            <AdviseeIcon />
            <InfoText>
              {name}, {age}
            </InfoText>
          </Row>
          <Row>
            <Col span={24}>
              <Row align="top">
                <ContentDisplay
                  isBold
                  isDisplayInSmallerContainer={isInDetailPage}
                  textToDisplay={Locale.get("addNewAdvisee.dob")}
                />
                <ContentDisplay
                  isDisplayInSmallerContainer={isInDetailPage}
                  textToDisplay={moment(dob).format("YYYY-MM-DD")}
                />
              </Row>
            </Col>
            <Col span={24}>
              {occupation && (
                <Row align="top" style={{ marginTop: "16px" }}>
                  <ContentDisplay
                    isBold
                    isDisplayInSmallerContainer={isInDetailPage}
                    textToDisplay={Locale.get("proposal.occupation")}
                  />
                  <ContentDisplay
                    isDisplayInSmallerContainer={isInDetailPage}
                    textToDisplay={occupation}
                  />
                </Row>
              )}
            </Col>
          </Row>
        </BasicInfoCard>
      </Col>
      {dependentYears > 0 && (
        <Col span={12}>
          <BasicInfoCard>
            <Row align="middle" style={{ marginBottom: "32px" }}>
              <DependentIcon />
              <InfoText>
                {Locale.get("proposal.responsibility")}{" "}
                {!isInDetailPage && Locale.get("proposal.information")}
              </InfoText>
            </Row>
            <Row align="top" gutter={8}>
              <ContentDisplay
                isBold
                isDisplayInSmallerContainer={isInDetailPage}
                textToDisplay={
                  isInDetailPage
                    ? Locale.get("proposal.minYear")
                    : Locale.get("proposal.yearsResponsibility")
                }
              />
              <ContentDisplay
                isDisplayInSmallerContainer={isInDetailPage}
                textToDisplay={`${dependentYears} ${Locale.get(
                  "proposal.years"
                )}`}
              />
            </Row>
            {noOfDependentFamilyMember > 0 && (
              <Row align="top" gutter={8} style={{ marginTop: "16px" }}>
                <ContentDisplay
                  isBold
                  isDisplayInSmallerContainer={isInDetailPage}
                  textToDisplay={`${Locale.get("proposal.dependent")}`}
                  // textToDisplay={`${Locale.get("proposal.dependent")}${
                  //   noOfDependentFamilyMember > 1 ? "s" : ""
                  // }`}
                />
                <ContentDisplay
                  isDisplayInSmallerContainer={isInDetailPage}
                  textToDisplay={noOfDependentFamilyMember}
                />
              </Row>
            )}
          </BasicInfoCard>
        </Col>
      )}
    </Row>
  );
};

export default SummaryInfoCard;
